/** Small helpers of the site's forms. */

/** The string value of a named field ("" when absent). */
export function formValue(form: HTMLFormElement, name: string): string {
  const value = new FormData(form).get(name);
  return typeof value === "string" ? value : "";
}

export function isBusy(form: HTMLFormElement): boolean {
  return form.getAttribute("aria-busy") === "true";
}

/** Disable a form's controls while its request runs (no double submit). */
export function setBusy(form: HTMLFormElement, busy: boolean): void {
  form.setAttribute("aria-busy", String(busy));
  for (const control of form.elements) {
    if (
      control instanceof HTMLButtonElement ||
      control instanceof HTMLInputElement ||
      control instanceof HTMLSelectElement
    ) {
      control.disabled = busy;
    }
  }
}

/** Length of a password in UTF-8 bytes (the server's rule counts bytes). */
export function byteLength(text: string): number {
  return new TextEncoder().encode(text).length;
}
